import React, { useContext } from 'react';
import NumberFormat from 'react-number-format';

// @material-ui/core components
import Typography from '@material-ui/core/Typography';

// mobx components
import { observer } from 'mobx-react';
import AssetStoreContext from '../../stores/AssetStore';

const SectionTotalPatrimony = observer(({ lang }) => {
  const assetStore = useContext(AssetStoreContext);

  return (
    <div>
      <Typography gutterBottom>
        {lang.assetTotal}{' '}
        <span
          style={{
            color: '#000',
            fontSize: '18px',
            lineHeight: '135%',
            width: '100%',
            wordBreak: 'break-word',
            margin: '0px',
            fontWeight: '600'
          }}
        >
          <NumberFormat
            value={assetStore.totalAssets}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
          />
          {/* ${assetStore.totalAssets} */}
        </span>
      </Typography>
      <Typography gutterBottom>
        {lang.passiveTotal}{' '}
        <span
          style={{
            color: '#000',
            fontSize: '18px',
            lineHeight: '135%',
            width: '100%',
            wordBreak: 'break-word',
            margin: '0px',
            fontWeight: '600'
          }}
        >
          <NumberFormat
            value={assetStore.totalPassive}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
          />
          {/* ${assetStore.totalPassive} */}
        </span>
      </Typography>
      <Typography gutterBottom>
        {lang.passiveHeritage}{' '}
        <span
          style={{
            color: '#000',
            fontSize: '18px',
            lineHeight: '135%',
            width: '100%',
            wordBreak: 'break-word',
            margin: '0px',
            fontWeight: '600'
          }}
        >
          <NumberFormat
            value={assetStore.patrimony}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
          />
          {/* ${assetStore.patrimony} */}
        </span>
      </Typography>
      <div
        style={{
          border: '2px solid #b7b1b1',
          padding: '5px',
          margin: '25px'
        }}
      >
        <p>{lang.passiveDescription}</p>
      </div>
    </div>
  );
});

export default SectionTotalPatrimony;
